import contextSlice from './slices/contextSlice';
import spinnerSlice from './slices/spinnerSlice';

export const getSlices = () => ({
  context: contextSlice.reducer,
  spinner: spinnerSlice.reducer,
});
